import React from 'react';

const CorrectionDownload: React.FC = () => {
  return (
    <div className="correction-download">
      <div className="template-container">
        <div className="template-content">
          {/* 汽機車險 */}
          <div className="vehicle-insurance">
            <div className="vehicle-insurance__title">汽機車險</div>
            <div className="vehicle-insurance__content">
              <div className="vehicle-insurance__table">
                <table>
                  <thead>
                    <tr>
                      <th>批改說明</th>
                      <th>檔案下載</th>
                      <th>填寫參考範例</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>保單補發</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                    <tr>
                      <td>保單退保</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                    <tr>
                      <td>保單資料更正</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="vehicle-insurance__remark">
                <div className="vehicle-insurance__remark-title">備註</div>
                <ol>
                  <li>1.下載之申請書尚有資料需填寫並簽名，請參考<span className="element__link">填寫範例</span></li>
                  <li>2.下載之申請書需連同(<span className="element__link">應備文件</span>)送至(就近的<span className="element__link">服務處所</span>)臨櫃辦理。</li>
                </ol>
              </div>
            </div>
          </div>
          {/* 住宅火險 */}
          <div className="fire-insurance">
            <div className="fire-insurance__title">住宅火險</div>
            <div className="fire-insurance__content">
              <div className="fire-insurance__table">
                <table>
                  <thead>
                    <tr>
                      <th>批改說明</th>
                      <th>檔案下載</th>
                      <th>填寫參考範例</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>保單退保</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                    <tr>
                      <td>資料批改</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="vehicle-insurance__remark">
                <div className="vehicle-insurance__remark-title">備註</div>
                <ol>
                  <li>1.下載之申請書尚有資料需填寫並簽名，請參考<span className="element__link">填寫範例</span></li>
                  <li>2.下載之申請書需連同(<span className="element__link">應備文件</span>)送至(就近的<span className="element__link">服務處所</span>)臨櫃辦理。</li>
                </ol>
              </div>
            </div>
          </div>
          {/* 旅遊險 */}
          <div className="travel-insurance">
            <div className="travel-insurance__title">旅遊險</div>
            <div className="travel-insurance__content">
              <div className="travel-insurance__table">
                <table>
                  <thead>
                    <tr>
                      <th>批改說明</th>
                      <th>檔案下載</th>
                      <th>填寫參考範例</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>文字批正申請</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                    <tr>
                      <td>保單加保/退保(須於保險生效日前辦理)</td>
                      <td>
                        <button type="button" className="element__button element__button--black">檔案下載</button>
                      </td>
                      <td>
                        <button type="button" className="element__button element__button--black">範例下載</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="vehicle-insurance__remark">
                <div className="vehicle-insurance__remark-title">備註</div>
                <ol>
                  <li>1.下載之申請書尚有資料需填寫並簽名，請參考<span className="element__link">填寫範例</span></li>
                  <li>2.下載之申請書需連同(<span className="element__link">應備文件</span>)送至(就近的<span className="element__link">服務處所</span>)臨櫃辦理。</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorrectionDownload;
